import { render } from "./unresize.vue?vue&type=template&id=05fdb380&scoped=true"
import script from "./unresize.vue?vue&type=script&lang=js"
export * from "./unresize.vue?vue&type=script&lang=js"

import "./unresize.vue?vue&type=style&index=0&id=05fdb380&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fdb380"]])

export default __exports__